var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileServerCardDisabled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ic_sync_onprem_card",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group-3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Oval"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#f5f5f5"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Combined-Shape",
    d: "M39,19v5.6H15V19Zm-1.5,2.1H36v1.4h1.5Zm-3,0H33v1.4h1.5Zm-3,0H30v1.4h1.5Z",
    transform: "translate(-3 -0.8)",
    fill: "#c8c8c8",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Combined-Shape-Copy",
    d: "M39,27v5.6H15V27Zm-1.5,2.1H36v1.4h1.5Zm-3,0H33v1.4h1.5Zm-3,0H30v1.4h1.5Z",
    transform: "translate(-3 -2.4)",
    fill: "#c8c8c8",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileServerCardDisabled);
export default __webpack_public_path__ + "static/media/file-server-card-disabled.035f8b1de1c0bb44890095ed114dba25.svg";
export { ForwardRef as ReactComponent };